import { AssessmentStatus as Assessment_Status_Enum } from '@risksmart-app/domain/src/types/consts/assessment-status';
import {
  CustomAttributeDataSchema,
  InheritedContributorSchema,
  NullableStringDateSchema,
  TagsAndDepartmentsSchema,
  UserOptionSchema,
  UserOrGroupsSchema,
} from 'src/schemas/global';
import { z } from 'zod';

const BaseAssessmentSchema = z.object({
  Title: z.string().min(1, { message: 'Required' }),
  Summary: z.string(),
  ActualCompletionDate: NullableStringDateSchema,
  NextTestDate: NullableStringDateSchema,
  StartDate: NullableStringDateSchema,
  TargetCompletionDate: NullableStringDateSchema,
  CompletedByUser: UserOptionSchema.nullable(),
  Contributors: UserOrGroupsSchema,
  Viewers: UserOrGroupsSchema,
  Status: z.nativeEnum(Assessment_Status_Enum).nullish(),
  Outcome: z.number().nullable(),
  Owners: UserOrGroupsSchema.min(1, { message: 'Required' }),
  ancestorContributors: InheritedContributorSchema,
});

export const AssessmentFormSchema = BaseAssessmentSchema.and(
  TagsAndDepartmentsSchema
).and(CustomAttributeDataSchema);

export type AssessmentFormDataFields = z.infer<typeof AssessmentFormSchema>;

export const defaultValues: AssessmentFormDataFields = {
  Title: '',
  Summary: '',
  ActualCompletionDate: null,
  NextTestDate: null,
  StartDate: null,
  TargetCompletionDate: null,
  CompletedByUser: null,
  Status: Assessment_Status_Enum.NotStarted,
  Outcome: null,
  tags: [],
  departments: [],
  CustomAttributeData: null,
  Contributors: [],
  Viewers: [],
  Owners: [],
  ancestorContributors: [],
};
